var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F617(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M41.543 50.37c1.582-1.638-1.828-2.965-1.828-5.87s3.41-4.232 1.828-5.87c-1.894-1.962-6.021-.479-8.581-3.13 0 2.151 1.805 4.5 5.18 4.5 0 0-2.294.925-2.294 4.5s2.294 4.5 2.294 4.5c-3.375 0-5.18 2.349-5.18 4.5 2.559-2.651 6.687-1.168 8.581-3.13z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 20.499,
    cy: 25.592,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 43.499,
    cy: 25.592,
    r: 5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#917524"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.202 16.661a14.232 14.232 0 0 0-11.693-3.133c-.578.113-1.088-2.021-.385-2.156a16.42 16.42 0 0 1 13.492 3.615c.541.469-.97 2.061-1.414 1.674zM25.487 13.378c-4.168-.748-8.452.4-11.69 3.133-.443.389-1.953-1.205-1.412-1.674a16.415 16.415 0 0 1 13.489-3.615c.703.134.191 2.269-.387 2.156z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F617);
export default __webpack_public_path__ + "static/media/1f617.6b747d75cac14509bb1a4bad64379625.svg";
export { ForwardRef as ReactComponent };